export default __webpack_public_path__ + "static/media/Viper_artwork.57513854.png";